import { api } from '../index';
import { TAxiosResponse } from '../baseApiTypes';
import { IExpertisesResponse } from './types';

export const getExpertises = (): TAxiosResponse<IExpertisesResponse> =>
  api.get('/expertises');

export const getExpertisesTree = (): TAxiosResponse<IExpertisesResponse> =>
  api.get('/expertisestree');
  
export const getExpertisesBeat = (): TAxiosResponse<IExpertisesResponse> =>
  api.get('/expertisesbeat');

export const ExpertisesApi = {
  getExpertises,
  getExpertisesTree,
  getExpertisesBeat,
};
